<template>
  <div class="poster">
    <van-dropdown-menu>
      <van-dropdown-item v-model="formData.cityId" :options="cityOptions" @change="cityChange" />
    </van-dropdown-menu>
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh" >
      <van-list
        ref="refList"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="50"
        finished-text="没有更多了"
        @load="onLoad"
      >
      <!-- v-if="tableData.length" -->
        <div class="list" >
          <table-list :tableData="tableData" :formData="formData"/>
          <!-- <van-pagination v-model="currentPage" :total-items="total" :items-per-page="pageSize" @change="changePage"/> -->
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <van-empty description="没有数据哦" v-else/> -->
  </div>
</template>

<script>
import { config } from "./config";
import { debounce } from "../../utils/utils";
import TableList from "./components/TableList.vue";

export default {
  components: { TableList },
  name: "yachSharePoster",
  data() {
    return {
      appid: config.appId,
      cityOptions: [],
      formData: {
        workCode: "",
        cityId: localStorage.getItem("poster_cityId") || "0",
      },
      currentPage: 1, // 当前页
      total: 0, // 总条数
      pageSize: 10, // 每页条数
      tableData: [],
      loading: false, // 是否加载中
      finished: false, // 是否加载完毕
      isRefresh: false, // 是否刷新中
    };
  },
  methods: {
    // 城市被切换
    cityChange() {
      this.onRefresh();
      localStorage.setItem("poster_cityId", this.formData.cityId);
    },
    // 获取城市列表
    getConfig() {
      this.$api.clueForm.getConfig().then((res) => {
        const cities = res.data.cities || [];
        const citylist = cities.map((item) => ({ text: item.cityName, value: item.cityCode }));
        this.cityOptions = [{ text: "全国", value: "0" }, ...citylist];
        this.getPosterList();
      });
    },
    // 切换页码
    // changePage(page) {
    //   this.currentPage = page;
    //   console.log("changePage", page);
    //   this.getPosterList();
    // },
    // 下拉刷新
    onRefresh() {
      this.loading = true;
      this.isRefresh = true;
      this.finished = false;
      this.currentPage = 1;
      this.getPosterList();
    },
    // 上拉加载
    onLoad() {
      this.loading = true;
      this.finished = false;
      this.currentPage++;
      this.getPosterList();
    },
    // 获取海报列表
    async getPosterList() {
      const data = {
        cityCode: this.formData.cityId,
        pageSize: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize,
      };
      data.cityCode === "0" && delete data.cityCode;
      const res = await this.$api.poster.getPosterList(data)
      // console.log("getPosterList", res);
      if(res.data.content){
        const datalist = res.data.content.map(item => ({...item, cityName: (this.cityOptions.find(city => city.value === item.cityCode) || {}).text || '其他'})) || [];
        datalist.forEach(item => item.posterInfo = JSON.parse(item.posterInfo)) // 将海报信息转为对象
        this.tableData = this.currentPage === 1 ? datalist : [...this.tableData, ...datalist];
        this.total = res.data.totalRows;
      }
      // 设置加载状态
      // debugger
      this.loading = false;
      this.isRefresh = false;
      if (this.tableData.length >= this.total) {
        this.finished = true;
      }
      // 判断是否触底
      this.$nextTick(() => {
        this.$refs.refList.check();
      });
    },
  },
  created() {
    let reg = /Android|webOS|iPhone|iPod|BlackBerry/i;
    if (!reg.test(window.navigator.userAgent)) {
      var html = document.getElementsByTagName("html")[0];
      html.style.fontSize = "40px";
    }
    window.onresize = debounce(function () {
      html.style.fontSize = "40px";
    }, 1000);

    this.$api.yach.getCheckLogin(this.appid).then((res) => {
      if (JSON.stringify(res) !== "{}") {
        // res.workName + "+" +
        this.formData.workCode = res.workCode;
      } else {
        this.isAdviser = true;
      }
      console.log("formData", this.formData);
      this.getConfig();
    });
  },
  mounted() {},
};
</script>

<style scoped>
.list {
  margin-top: 10px;
  padding-bottom: 50px;
}
</style>
